/* Configurateur maillot - one cart line per printed item, sharing a _TRIKOT id */
(function () {
  'use strict';

  function cartRoot() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function money(cents, fmt) {
    try {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
        return window.Shopify.formatMoney(cents, fmt || window.moneyFormat);
      }
    } catch (e) {
      /* fall through to the plain format below */
    }
    return 'CHF ' + (Number(cents) / 100).toFixed(2);
  }

  /* Personalisation hand-off across a jersey switch. Read-and-delete, and only IDENTITY travels - variant ids belong to the jersey being left, so the play */
  var CARRY_KEY = 'ls:jersey:carry';

  function saveCarry(data) {
    try {
      window.sessionStorage.setItem(CARRY_KEY, JSON.stringify(data));
    } catch (e) {
      /* private mode / quota - the carry is a nicety, never a requirement */
    }
  }

  function takeCarry() {
    try {
      var raw = window.sessionStorage.getItem(CARRY_KEY);
      window.sessionStorage.removeItem(CARRY_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function normName(v) {
    return String(v == null ? '' : v)
      .toLowerCase()
      .replace(/[.,'’`\-_]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function digitsOnly(v) {
    return String(v == null ? '' : v).replace(/\D/g, '');
  }

  // Lays a print box exactly over the PHOTO inside an image box, whatever its
  // object-fit (the section letterboxes, the PDP gallery crops), so the flock
  // percentages mean the same spot on the shirt everywhere
  function fitToPhoto(box, img) {
    if (!box || !img) return;
    function apply() {
      var nw = img.naturalWidth;
      var nh = img.naturalHeight;
      var host = box.offsetParent;
      if (!nw || !nh || !host) return;
      var ir = img.getBoundingClientRect();
      if (!ir.width || !ir.height) return;
      var hr = host.getBoundingClientRect();
      var ar = nw / nh;
      var fit = window.getComputedStyle(img).objectFit;
      var w = ir.width;
      var h = ir.height;
      if (fit === 'contain' || fit === 'scale-down') {
        h = Math.min(ir.height, ir.width / ar);
        w = h * ar;
      } else if (fit === 'cover') {
        h = Math.max(ir.height, ir.width / ar);
        w = h * ar;
      }
      box.style.inset = 'auto';
      box.style.left = ir.left - hr.left + (ir.width - w) / 2 + 'px';
      box.style.top = ir.top - hr.top + (ir.height - h) / 2 + 'px';
      box.style.width = w + 'px';
      box.style.height = h + 'px';
    }
    apply();
    img.addEventListener('load', apply);
    if (window.ResizeObserver) new ResizeObserver(apply).observe(img);
    return apply;
  }

  function init(root) {
    if (root.hasAttribute('data-jc-initialized')) return;
    root.setAttribute('data-jc-initialized', 'true');

    var cfgEl = root.querySelector('[data-jc-config]');
    if (!cfgEl) return;
    var config;
    try {
      config = JSON.parse(cfgEl.textContent);
    } catch (e) {
      return;
    }
    config.numbers = config.numbers || {};
    config.digits = config.digits || {};
    var strings = config.strings || {};
    var fmt = config.moneyFormat || window.moneyFormat;

    var state = {
      mode: 'none',
      player: null, // { variantId, name, number, price, sku }
      customName: '',
      customNumber: '',
      badges: [], // [{ variantId, title, price, sku }]
      variantId: null,
      variantPrice: Number(config.initialVariantPrice) || 0,
      sizeSelected: false,
      busy: false
    };

    // ---------- elements ----------
    var track = root.querySelector('[data-jc-track]');
    var dotsWrap = root.querySelector('[data-jc-dots]');
    var sizeWrap = root.querySelector('[data-jc-sizes]');
    var sizeLabel = root.querySelector('[data-jc-size-label]');
    var sizeError = root.querySelector('[data-jc-size-error]');
    var tabs = root.querySelectorAll('[data-jc-mode]');
    var playerField = root.querySelector('[data-jc-player-field]');
    var customField = root.querySelector('[data-jc-custom-field]');
    var selectTrigger = root.querySelector('[data-jc-select-trigger]');
    var selectValue = root.querySelector('[data-jc-select-value]');
    var selectMenu = root.querySelector('[data-jc-select-menu]');
    var playerOptions = root.querySelector('[data-jc-player-options]');
    var playerSearch = root.querySelector('[data-jc-player-search]');
    var nameInput = root.querySelector('[data-jc-name]');
    var numberInput = root.querySelector('[data-jc-number]');
    var customError = root.querySelector('[data-jc-custom-error]');
    var customNote = root.querySelector('[data-jc-custom-note]');
    var flockNote = root.querySelector('[data-jc-flock-note]');
    var badgesWrap = root.querySelector('[data-jc-badges]');
    var badgesNote = root.querySelector('[data-jc-badges-note]');
    var priceEl = root.querySelector('[data-jc-price]');
    var submit = root.querySelector('[data-jc-submit]');
    var messages = root.querySelector('[data-jc-messages]');
    var mobileToggle = root.querySelector('[data-jc-mobile-toggle]');

    // On the PDP the theme's variant picker owns the selection and the form
    var isPdp = root.hasAttribute('data-jc-pdp');
    var pdpForm = null;
    if (isPdp) {
      var formId = root.getAttribute('data-jc-form');
      pdpForm = (formId && document.getElementById(formId)) || document.querySelector('product-form form');
    }
    function pdpVariantId() {
      var input = pdpForm && pdpForm.querySelector('[name="id"]');
      return input ? input.value : null;
    }
    var defaultPlayerLabel = selectValue ? selectValue.textContent.trim() : '';

    function show(el, visible) {
      if (el) el.hidden = !visible;
    }

    function setError(el, msg) {
      if (!el) return;
      el.textContent = msg || '';
      el.hidden = !msg;
    }

    // Number product is either one variant per number or one per digit;
    // resolved from the actual variant maps, since it changes the price
    function sanitizeNumber(n) {
      return String(n || '').replace(/\D/g, '').slice(0, 2);
    }

    // Returns the add-on lines a number produces: one entry for a whole-number product, one per digit otherwise. Empty array when the nu
    function numberLines(n) {
      n = sanitizeNumber(n);
      if (!n) return [];
      var whole = config.numbers[n] || config.numbers[String(parseInt(n, 10))];
      if (whole) return [{ info: whole, flock: n }];
      var out = [];
      var parts = n.split('');
      for (var i = 0; i < parts.length; i++) {
        var d = config.digits[parts[i]];
        if (!d) return []; // an unmappable digit makes the whole number unusable
        out.push({ info: d, flock: n });
      }
      return out;
    }

    function numberIssue(n) {
      if (!sanitizeNumber(n)) return '';
      var lines = numberLines(n);
      if (!lines.length) return strings.numberUnavailable || '';
      for (var i = 0; i < lines.length; i++) {
        if (lines[i].info.available === false) return strings.numberUnavailable || '';
      }
      return '';
    }

    // Picking the tab is not a personalisation - the surcharge only lands
    // once something is actually entered
    function isPersonalized() {
      if (state.mode === 'player') return !!state.player;
      if (state.mode === 'custom') return !!(state.customName.trim() || state.customNumber.trim());
      return false;
    }

    // Printing surcharge only - badges are counted separately because they are
    // chosen independently of the flocage tab and are charged even in "sans"
    function personalizationCents() {
      var total = 0;
      if (!isPersonalized()) return 0;
      if (state.mode === 'player' && state.player) {
        // The player value is priced for the whole flock (number + name); the
        // number product is the custom tab's add-on and is never stacked on it
        total += Number(state.player.price) || 0;
      } else if (state.mode === 'custom') {
        if (state.customName.trim() && config.nameAddon) {
          total += Number(config.nameAddon.price) || 0;
        } else if (!state.customName.trim() && state.customNumber.trim() && config.noNameAddon) {
          // "No name" placeholder is charged whenever the jersey is printed at all
          total += Number(config.noNameAddon.price) || 0;
        }
        numberLines(state.customNumber).forEach(function (l) {
          total += Number(l.info.price) || 0;
        });
      }
      return total;
    }

    function badgeCents() {
      var total = 0;
      for (var i = 0; i < state.badges.length; i++) total += Number(state.badges[i].price) || 0;
      return total;
    }

    // PDP has no price node of its own in this element, so drive the theme's.
    // Always written from the variant price: the node's text is our own output
    // once anything was added, so it can never serve as the base
    var pdpPriceEl = isPdp ? document.querySelector('.pdp-figma__price .price-item--regular, .pdp-figma__price .price-item') : null;

    function applyPdpPrice() {
      if (!pdpPriceEl) return;
      var base = state.variantPrice || Number(config.initialVariantPrice) || 0;
      pdpPriceEl.textContent = money(base + personalizationCents() + badgeCents(), fmt);
    }

    // ---------- flock price note (right of the "Flocage" label) ----------
    // Shown for the open tab: the picked player's price, else the cheapest
    // player; on the custom tab the name + number flock
    function playerFromCents() {
      var min = 0;
      if (!playerOptions) return 0;
      playerOptions.querySelectorAll('.jc-select-option').forEach(function (o) {
        var p = Number(o.getAttribute('data-price')) || 0;
        if (p > 0 && (!min || p < min)) min = p;
      });
      return min;
    }

    function customFlockCents() {
      var total = config.nameAddon && nameInput ? Number(config.nameAddon.price) || 0 : 0;
      if (!numberInput) return total;
      var n = sanitizeNumber(state.customNumber);
      if (!n) {
        var keys = Object.keys(config.numbers).length ? Object.keys(config.numbers) : Object.keys(config.digits);
        n = keys.length ? keys[0] : '';
      }
      numberLines(n).forEach(function (l) {
        total += Number(l.info.price) || 0;
      });
      return total;
    }

    function syncFlockNote() {
      if (!flockNote) return;
      var cents = 0;
      if (state.mode === 'player') cents = state.player ? Number(state.player.price) || 0 : playerFromCents();
      else if (state.mode === 'custom') cents = customFlockCents();
      var text = cents > 0 && strings.flockPrice ? strings.flockPrice.replace('__PRICE__', money(cents, fmt)) : '';
      flockNote.textContent = text;
      flockNote.hidden = !text;
    }

    // ---------- number + name are one purchase ----------
    // Both inputs present means neither may be bought alone: the note shows as
    // soon as one is filled, and add to cart stays locked until both are
    var needsBoth = !!(nameInput && numberInput);

    function customIncomplete() {
      if (state.mode !== 'custom' || !needsBoth) return false;
      return !(state.customName.trim() && state.customNumber.trim());
    }

    var pdpSubmit = isPdp && pdpForm ? pdpForm.querySelector('[name="add"]') : null;
    var cartLocked = false;

    function pdpVariantAvailable() {
      var map = config.variantAvailable || {};
      return map[state.variantId] !== false;
    }

    function syncCustomGate() {
      var name = state.customName.trim();
      var number = state.customNumber.trim();
      if (customNote) customNote.hidden = !(state.mode === 'custom' && needsBoth && !!name !== !!number);
      cartLocked = customIncomplete();
      if (submit && !state.busy) submit.disabled = cartLocked;
      if (pdpSubmit) {
        if (cartLocked) pdpSubmit.setAttribute('disabled', 'disabled');
        else if (pdpSubmit.hasAttribute('data-jc-locked')) {
          // Hand the button back in the state the theme would give it
          if (pdpVariantAvailable()) pdpSubmit.removeAttribute('disabled');
        }
        pdpSubmit.toggleAttribute('data-jc-locked', cartLocked);
      }
    }

    // The theme re-enables its button on every variant swap; keep it locked
    if (pdpSubmit && window.MutationObserver) {
      new MutationObserver(function () {
        if (cartLocked && !pdpSubmit.hasAttribute('disabled')) pdpSubmit.setAttribute('disabled', 'disabled');
      }).observe(pdpSubmit, { attributes: true, attributeFilter: ['disabled'] });
    }

    function applyPrice() {
      applyStockCap();
      syncFlockNote();
      syncCustomGate();
      applyPdpPrice();
      if (!priceEl) return;
      // Sizes can differ in price. Until one is picked there is no single exact total, so show the cheapest prefixed with "À partir de"; t
      var showFrom = config.priceVaries && !state.sizeSelected;
      var base = showFrom ? Number(config.priceMin) || 0 : state.variantPrice;
      var text = money(base + personalizationCents() + badgeCents(), fmt);
      if (showFrom && config.fromPriceTemplate) {
        priceEl.innerHTML = config.fromPriceTemplate.replace('__PRICE__', text);
      } else {
        priceEl.textContent = text;
      }
    }

    // ---------- carousel ----------
    function setupCarousel() {
      if (!track || !dotsWrap) return;
      var slides = track.querySelectorAll('.jc-slide');
      if (slides.length < 2) return;

      for (var i = 0; i < slides.length; i++) {
        (function (index) {
          var dot = document.createElement('button');
          dot.type = 'button';
          dot.className = 'jc-dot' + (index === 0 ? ' is-active' : '');
          dot.setAttribute('aria-label', 'Image ' + (index + 1));
          dot.addEventListener('click', function () {
            track.scrollTo({ left: slides[index].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
        })(i);
      }

      var dots = dotsWrap.querySelectorAll('.jc-dot');
      var raf = null;
      track.addEventListener('scroll', function () {
        if (raf) return;
        raf = window.requestAnimationFrame(function () {
          raf = null;
          var current = Math.round(track.scrollLeft / track.clientWidth);
          for (var d = 0; d < dots.length; d++) {
            dots[d].classList.toggle('is-active', d === current);
          }
        });
      });
    }

    // ---------- size ----------
    function selectSize(btn) {
      if (!btn || btn.getAttribute('data-available') === 'false') return;
      state.variantId = btn.getAttribute('data-variant-id');
      state.variantPrice = Number(btn.getAttribute('data-price')) || state.variantPrice;
      state.sizeSelected = true;
      var all = sizeWrap.querySelectorAll('[data-jc-size]');
      for (var i = 0; i < all.length; i++) all[i].classList.toggle('is-active', all[i] === btn);
      if (sizeLabel) sizeLabel.textContent = btn.getAttribute('data-title') || '';
      setError(sizeError, '');
      applyPrice();
    }

    if (sizeWrap) {
      sizeWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jc-size]');
        if (btn) selectSize(btn);
      });
    }

    // ---------- flock preview on the back photo ----------
    var printBox = root.querySelector('[data-jc-print]');
    var printName = root.querySelector('[data-jc-print-name]');
    var printNumber = root.querySelector('[data-jc-print-number]');
    var backIndex = track ? parseInt(track.getAttribute('data-jc-back-index'), 10) : -1;

    // Offset relative to the FIRST slide, not to the track: the track is not a positioned ancestor, so slide.offsetLeft is measured agai
    // PDP: the theme's gallery owns the images, so switch it via its thumbnail
    var backMediaId = root.getAttribute('data-jc-back-media') || '';
    var firstMediaEl = document.querySelector('.product__media-item');
    var firstMediaId = firstMediaEl ? String(firstMediaEl.dataset.mediaId || '').split('-').pop() : '';
    function showGalleryMedia(mediaId) {
      if (!mediaId) return;
      var thumb = document.querySelector('[data-target$="-' + mediaId + '"]');
      var link = thumb && (thumb.querySelector('button, a') || thumb);
      if (link) {
        link.click();
        return;
      }
      var gallery = document.querySelector('media-gallery');
      var item = document.querySelector('.product__media-item[data-media-id$="-' + mediaId + '"]');
      if (gallery && item && typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(item.dataset.mediaId, true);
      }
    }

    function goToSlide(i) {
      if (!track || i < 0) return;
      var slides = track.querySelectorAll('.jc-slide');
      if (!slides[i] || !slides[0]) return;
      track.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth' });
    }

    // Optical centring: "14" leans right when centred geometrically. Measured
    // off-screen, returned in EM so it scales with the print
    var _octx = null;
    function opticalShiftEm(el, text) {
      if (!text) return 0;
      try {
        if (!_octx) {
          var c = document.createElement('canvas');
          c.width = 1024; c.height = 512;
          _octx = c.getContext('2d', { willReadFrequently: true });
        }
        var cs = getComputedStyle(el), SIZE = 256;
        _octx.clearRect(0, 0, 1024, 512);
        _octx.textBaseline = 'middle';
        _octx.textAlign = 'center';
        _octx.font = (cs.fontWeight || '700') + ' ' + SIZE + 'px ' + (cs.fontFamily || 'sans-serif');
        _octx.fillStyle = '#000';
        _octx.fillText(text, 512, 256);
        var d = _octx.getImageData(0, 0, 1024, 512).data;
        var minX = 1e9, maxX = -1, sum = 0, wsum = 0;
        for (var y = 0; y < 512; y++) {
          var row = y * 1024;
          for (var x = 0; x < 1024; x++) {
            var a = d[(row + x) * 4 + 3];
            if (a > 40) { if (x < minX) minX = x; if (x > maxX) maxX = x; sum += a; wsum += a * x; }
          }
        }
        if (maxX < 0 || !sum) return 0;
        var bbox = (minX + maxX) / 2, com = wsum / sum, inkW = (maxX - minX) || 1;
        // Only ever nudge LEFT: right-heavy numbers need pulling back, left-heavy
        // ones already read fine centred and look wrong pushed right
        return Math.min(0, -(((com - bbox) / inkW) * (inkW / SIZE)));
      } catch (e) {
        return 0;
      }
    }

    // Patches go on the FRONT; placement is by badge name, same slot every jersey
    function badgeSlot(title) {
      var t = String(title || '').toLowerCase();
      if (t.indexOf('ubs') > -1) return 'chest-left';
      // League badge: "Brack Super League" or its short name "SFL"
      if (t.indexOf('brack') > -1 || t.indexOf('sfl') > -1) return 'shoulder-right';
      return '';
    }

    var frontStage = null;
    var frontStageFit = null;
    function ensureFrontStage() {
      if (frontStage && frontStage.isConnected) return frontStage;
      var host = null;
      if (isPdp) {
        var item = firstMediaId
          ? document.querySelector('.product__media-item[data-media-id$="-' + firstMediaId + '"]')
          : document.querySelector('.product__media-item');
        host = item && item.querySelector('.product__media');
      } else if (track) {
        var slide = track.querySelector('.jc-slide');
        host = slide && slide.querySelector('.jc-slide-media');
      }
      if (!host) return null;
      frontStage = host.querySelector('[data-jc-patches]');
      if (!frontStage) {
        frontStage = document.createElement('div');
        // The PDP stage is not square like the section's slide, so slots can differ
        frontStage.className =
          'jc-print-stage' +
          (isPdp ? ' jc-print-stage--pdp' : '') +
          // pantone_color wins: the kids third kit carries white_print too
          (root.classList.contains('jc--pantone-print')
            ? ' jc-print-stage--pantone'
            : root.classList.contains('jc--white-print')
              ? ' jc-print-stage--white-print'
              : '');
        frontStage.setAttribute('data-jc-patches', '');
        host.appendChild(frontStage);
        // Same photo-relative frame as the flock, so one set of slots holds on
        // the letterboxed section slide and the cropped PDP gallery alike
        frontStageFit = fitToPhoto(frontStage, host.querySelector('img'));
      }
      return frontStage;
    }

    function refreshPatches() {
      var stage = ensureFrontStage();
      if (!stage) return;
      stage.innerHTML = '';
      state.badges.forEach(function (b) {
        var slot = badgeSlot(b.title);
        if (!slot || !b.image) return;
        // Wrapper carries the size: the theme's .media img rules outrank any class here
        var patch = document.createElement('div');
        patch.className = 'jc-patch jc-patch--' + slot;
        var img = document.createElement('img');
        img.src = b.image;
        img.alt = '';
        img.style.width = '100%';
        img.style.height = 'auto';
        img.style.display = 'block';
        patch.appendChild(img);
        stage.appendChild(patch);
      });
      if (frontStageFit) frontStageFit();
    }

    // The length steps only count characters; wide letters (Club Winers caps)
    // still ran off the shirt, so the rendered name is capped to the back's width
    var NAME_MAX_WIDTH = 0.38; // share of the photo width: a little wider than INEOS
    function fitName() {
      if (!printName || !printBox) return;
      printName.style.setProperty('--jc-name-fit', '1');
      if (!printName.textContent) return;
      var boxW = printBox.getBoundingClientRect().width;
      if (!boxW) return; // not laid out yet (hidden slide); re-run on resize
      var range = document.createRange();
      range.selectNodeContents(printName);
      var textW = range.getBoundingClientRect().width;
      var maxW = boxW * NAME_MAX_WIDTH;
      if (textW > maxW) printName.style.setProperty('--jc-name-fit', (maxW / textW).toFixed(4));
    }

    function refreshPrint() {
      if (!printBox) return;
      var name = '', number = '';
      if (state.mode === 'player' && state.player) {
        name = state.player.name;
        number = state.player.number;
      } else if (state.mode === 'custom') {
        name = state.customName.trim();
        number = state.customNumber.trim();
      }
      if (printName) {
        printName.textContent = (name || '').toUpperCase();
        var len = (name || '').length;
        printName.classList.remove('is-medium', 'is-long', 'is-very-long');
        if (len > 12) printName.classList.add('is-very-long');
        else if (len > 9) printName.classList.add('is-long');
        else if (len > 6) printName.classList.add('is-medium');
        fitName();
      }
      if (printNumber) {
        printNumber.textContent = number || '';
        printNumber.style.setProperty(
          '--jc-number-optical',
          (number ? opticalShiftEm(printNumber, number).toFixed(4) : '0') + 'em'
        );
      }
      printBox.classList.toggle('is-on', !!(name || number));
    }

    // ---------- flocage tabs ----------
    function setMode(mode) {
      state.mode = mode;
      for (var i = 0; i < tabs.length; i++) {
        var active = tabs[i].getAttribute('data-jc-mode') === mode;
        tabs[i].classList.toggle('is-active', active);
        tabs[i].setAttribute('aria-selected', active ? 'true' : 'false');
      }
      show(playerField, mode === 'player');
      show(customField, mode === 'custom');

      // Leaving a mode clears its entry, so the cart can never carry a value
      // from a tab the shopper has switched away from
      if (mode !== 'player') resetPlayer();
      if (mode !== 'custom') {
        state.customName = '';
        state.customNumber = '';
        if (nameInput) nameInput.value = '';
        if (numberInput) numberInput.value = '';
      }
      setError(customError, '');
      // Personalising is a back-of-shirt action; "sans" returns to the front
      if (isPdp) {
        // Personalising is a back-of-shirt action: show what is being changed
        if (mode === 'none') {
          showGalleryMedia(firstMediaId);
        } else {
          showGalleryMedia(backMediaId);
        }
      } else {
        goToSlide(mode === 'none' ? 0 : backIndex);
      }
      refreshPrint();
      applyPrice();
    }

    for (var t = 0; t < tabs.length; t++) {
      (function (tab) {
        tab.addEventListener('click', function () {
          setMode(tab.getAttribute('data-jc-mode'));
        });
      })(tabs[t]);
    }

    function hasTab(mode) {
      for (var i = 0; i < tabs.length; i++) {
        if (tabs[i].getAttribute('data-jc-mode') === mode) return true;
      }
      return false;
    }

    // ---------- player select ----------
    // The roster's variant order is whatever the ERP / shop editor pushed, so
    // sort by shirt number, then by name with accents collated like their base
    // letter (É with E). Entries without a number go last.
    function playerNumber(o) {
      var n = parseInt(digitsOnly(o.getAttribute('data-number')), 10);
      if (!isNaN(n) && n < 1000) return n;
      // Hand-added variants can carry the number in the title in another shape
      // ("#10 Name", "Name 10", "Name - 10") that the Liquid split missed.
      var m = String(o.getAttribute('data-name') || '').match(/(?:^|[\s#-])(\d{1,3})(?=[\s.,-]|$)/);
      return m ? parseInt(m[1], 10) : 1e9;
    }

    (function sortPlayers() {
      if (!playerOptions) return;
      var collator = window.Intl && Intl.Collator ? new Intl.Collator('fr', { sensitivity: 'base', numeric: true }) : null;
      var rows = [];
      playerOptions.querySelectorAll('.jc-select-option').forEach(function (o, i) {
        var name = String(o.getAttribute('data-name') || '').trim();
        rows.push({ el: o, no: playerNumber(o), name: name, i: i });
      });
      rows.sort(function (a, b) {
        var byName = collator ? collator.compare(a.name, b.name) : a.name.localeCompare(b.name);
        return a.no - b.no || byName || a.i - b.i;
      });
      rows.forEach(function (r) {
        playerOptions.appendChild(r.el);
      });
    })();

    function closeSelect() {
      if (!selectMenu) return;
      selectMenu.hidden = true;
      if (selectTrigger) selectTrigger.setAttribute('aria-expanded', 'false');
    }

    function resetPlayer() {
      state.player = null;
      if (selectValue) selectValue.textContent = defaultPlayerLabel;
      if (selectTrigger) selectTrigger.classList.add('is-placeholder');
      if (playerOptions) {
        playerOptions.querySelectorAll('.jc-select-option').forEach(function (o) {
          o.classList.remove('is-selected');
        });
      }
      closeSelect();
    }

    function selectPlayer(opt) {
      if (!opt || opt.getAttribute('data-available') === 'false') return false;
      state.player = {
        variantId: opt.getAttribute('data-variant-id'),
        name: opt.getAttribute('data-name') || '',
        number: digitsOnly(opt.getAttribute('data-number')),
        price: Number(opt.getAttribute('data-price')) || 0,
        sku: opt.getAttribute('data-sku') || '',
        stock: parseInt(opt.getAttribute('data-stock'), 10)
      };
      if (selectValue) {
        selectValue.textContent = (state.player.number ? state.player.number + ' - ' : '') + state.player.name;
      }
      if (selectTrigger) selectTrigger.classList.remove('is-placeholder');
      playerOptions.querySelectorAll('.jc-select-option').forEach(function (o) {
        o.classList.toggle('is-selected', o === opt);
      });
      closeSelect();
      refreshPrint();
      applyPrice();
      return true;
    }

    if (selectTrigger && selectMenu) {
      selectTrigger.classList.add('is-placeholder');
      selectTrigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = selectMenu.hidden;
        selectMenu.hidden = !open;
        selectTrigger.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && playerSearch) {
          playerSearch.value = '';
          playerOptions.querySelectorAll('.jc-select-option').forEach(function (o) {
            o.style.display = '';
          });
          window.setTimeout(function () {
            playerSearch.focus();
          }, 40);
        }
      });
    }

    if (playerSearch) {
      playerSearch.addEventListener('click', function (e) {
        e.stopPropagation();
      });
      playerSearch.addEventListener('input', function () {
        var q = playerSearch.value.toLowerCase();
        playerOptions.querySelectorAll('.jc-select-option').forEach(function (o) {
          var hay = ((o.getAttribute('data-number') || '') + ' ' + (o.getAttribute('data-name') || '')).toLowerCase();
          o.style.display = hay.indexOf(q) > -1 ? '' : 'none';
        });
      });
    }

    if (playerOptions) {
      playerOptions.addEventListener('click', function (e) {
        var opt = e.target.closest('.jc-select-option');
        if (opt) selectPlayer(opt);
      });
    }

    document.addEventListener('click', function (e) {
      if (selectMenu && !selectMenu.hidden && !e.target.closest('[data-jc-select]')) closeSelect();
    });

    // ---------- custom inputs ----------
    if (nameInput) {
      nameInput.addEventListener('input', function () {
        state.customName = nameInput.value;
        refreshPrint();
        applyPrice();
      });
    }

    if (numberInput) {
      numberInput.addEventListener('input', function () {
        var clean = sanitizeNumber(numberInput.value);
        if (clean !== numberInput.value) numberInput.value = clean;
        state.customNumber = clean;
        setError(customError, numberIssue(clean));
        refreshPrint();
        applyPrice();
      });
    }

    // ---------- badges ---------- Shown only once a badge is actually picked: the selected badge names joined with " + ", then the SUM
    function syncBadgesNote() {
      if (!badgesNote) return;
      if (!state.badges.length) {
        badgesNote.textContent = '';
        return;
      }
      var names = state.badges.map(function (b) {
        return b.title;
      });
      var total = badgeCents();
      badgesNote.textContent = names.join(' + ') + (total ? ' ( + ' + money(total, fmt) + ')' : '');
    }

    if (badgesWrap) {
      badgesWrap.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-jc-badge]');
        if (!btn || btn.getAttribute('data-available') === 'false') return;
        var id = btn.getAttribute('data-variant-id');
        var idx = -1;
        for (var i = 0; i < state.badges.length; i++) {
          if (state.badges[i].variantId === id) idx = i;
        }
        if (idx > -1) {
          state.badges.splice(idx, 1);
          btn.setAttribute('aria-pressed', 'false');
        } else {
          state.badges.push({
            variantId: id,
            title: btn.getAttribute('data-title') || '',
            price: Number(btn.getAttribute('data-price')) || 0,
            sku: btn.getAttribute('data-sku') || '',
            image: btn.getAttribute('data-image') || '',
            stock: parseInt(btn.getAttribute('data-stock'), 10)
          });
          btn.setAttribute('aria-pressed', 'true');
        }
        syncBadgesNote();
        refreshPatches();
        applyPrice();
      });
    }

    // ---------- description ----------
    var descToggle = root.querySelector('[data-jc-desc-toggle]');
    var descContent = root.querySelector('[data-jc-desc-content]');
    if (descToggle && descContent) {
      descToggle.addEventListener('click', function () {
        var open = descContent.hidden;
        descContent.hidden = !open;
        descToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      });

      // Pasted Word/Outlook markup: a <style> in the body applies document-wide,
      // so the nodes are removed rather than hidden
      descContent.querySelectorAll('style, meta, link, title').forEach(function (n) {
        n.remove();
      });
      descContent.querySelectorAll('[style]').forEach(function (n) {
        ['font-family', 'font-size', 'line-height', 'background', 'background-color'].forEach(function (p) {
          n.style.removeProperty(p);
        });
        if (!n.getAttribute('style')) n.removeAttribute('style');
      });
    }

    // ---------- mobile expand ----------
    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        root.classList.add('is-expanded');
        mobileToggle.setAttribute('aria-expanded', 'true');
      });
    }

    // ---------- jersey switch (Section Rendering API) ----------
    root.querySelectorAll('[data-jc-switch-handle]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        if (a.classList.contains('is-active')) {
          e.preventDefault();
          return;
        }
        var handle = a.getAttribute('data-jc-switch-handle');
        var fallback = a.getAttribute('href');
        // Hand the entry to whatever renders next - the swapped-in section
        // below, or the sibling's PDP when the fetch fails and we navigate
        saveCarry(snapshot());
        if (!handle || !config.sectionId) return;
        e.preventDefault();
        if (root.classList.contains('jc--switching')) return;
        // Skeleton over the current jersey until the next one is ready to paint
        root.classList.add('jc--switching');
        root.setAttribute('aria-busy', 'true');
        root.querySelectorAll('[data-jc-switch-handle]').forEach(function (x) {
          x.classList.toggle('is-active', x === a);
        });
        // Fetch the sibling's product URL so the GLOBAL product drives the render; Liquid cannot read query params, so a section_id fetch ag
        var url = cartRoot() + 'products/' + encodeURIComponent(handle) + '?section_id=' + encodeURIComponent(config.sectionId);
        fetch(url)
          .then(function (r) {
            return r.text();
          })
          .then(function (html) {
            var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-jc]');
            if (!fresh) {
              window.location.href = fallback;
              return;
            }
            // Swap only once the first photo is decoded, or the skeleton gives
            // way to an empty frame
            return preloadFirstSlide(fresh).then(function () {
              // A Neo slot hides every [data-ls-slot-source] until it is marked
              // placed; the fetched node is unmarked, so it inherits the marks
              ['is-placed', 'is-slotted'].forEach(function (c) {
                if (root.classList.contains(c)) fresh.classList.add(c);
              });
              // Mobile: an opened configurator stays open on the next jersey
              if (root.classList.contains('is-expanded')) {
                fresh.classList.add('is-expanded');
                var freshToggle = fresh.querySelector('[data-jc-mobile-toggle]');
                if (freshToggle) freshToggle.setAttribute('aria-expanded', 'true');
              }
              fresh.classList.add('jc--switched');
              root.replaceWith(fresh);
              init(fresh);
            });
          })
          .catch(function () {
            window.location.href = fallback;
          });
      });
    });

    // Resolves when the fresh section's first slide can paint (capped, so a
    // slow image never blocks the switch)
    function preloadFirstSlide(fresh) {
      var img = fresh.querySelector('.jc-slide img');
      if (!img) return Promise.resolve();
      img.setAttribute('loading', 'eager');
      var probe = new Image();
      if (img.getAttribute('sizes')) probe.sizes = img.getAttribute('sizes');
      if (img.getAttribute('srcset')) probe.srcset = img.getAttribute('srcset');
      probe.src = img.getAttribute('src');
      var ready = probe.decode ? probe.decode().catch(function () {}) : new Promise(function (res) {
        probe.onload = probe.onerror = res;
      });
      return Promise.race([
        ready,
        new Promise(function (res) {
          window.setTimeout(res, 2500);
        })
      ]);
    }

    function snapshot() {
      return {
        mode: state.mode,
        name: state.customName,
        number: state.customNumber,
        player: state.player ? { name: state.player.name, number: state.player.number } : null
      };
    }

    // Same player on the new jersey: match on NAME, preferring the entry that also carries the same number. Never match on number alone
    function findPlayerOption(p) {
      if (!playerOptions || !p) return null;
      var wantName = normName(p.name);
      if (!wantName) return null;
      var wantNo = digitsOnly(p.number);
      var opts = playerOptions.querySelectorAll('.jc-select-option');
      var byName = null;
      for (var i = 0; i < opts.length; i++) {
        var o = opts[i];
        if (o.getAttribute('data-available') === 'false') continue;
        if (normName(o.getAttribute('data-name')) !== wantName) continue;
        if (wantNo && digitsOnly(o.getAttribute('data-number')) === wantNo) return o;
        if (!byName) byName = o;
      }
      return byName;
    }

    function restore(carry) {
      var mode = carry && (carry.mode === 'player' || carry.mode === 'custom') ? carry.mode : 'none';
      // A jersey without that add-on product has no such tab - fall back to
      // "sans" rather than leaving an invisible mode selected
      if (!hasTab(mode)) mode = 'none';
      setMode(mode);
      if (mode === 'custom') {
        if (nameInput && carry.name) {
          var max = parseInt(nameInput.getAttribute('maxlength'), 10) || 0;
          nameInput.value = max > 0 ? String(carry.name).slice(0, max) : String(carry.name);
          state.customName = nameInput.value;
        }
        if (numberInput && carry.number) {
          var n = sanitizeNumber(carry.number);
          numberInput.value = n;
          state.customNumber = n;
          // This jersey has its own number variants: flag an unavailable number
          // right away, exactly as typing it would
          setError(customError, numberIssue(n));
        }
        refreshPrint();
        applyPrice();
      } else if (mode === 'player' && carry.player) {
        // No match (not on this roster, or sold out here) leaves the select on its placeholder, so the shopper sees they must pick again rat
        selectPlayer(findPlayerOption(carry.player));
      }
    }

    // How many complete bundles can be ordered: the smallest stock across the
    // jersey and every add-on, since one add-to-cart has to satisfy them all
    function bundleStock() {
      var caps = [];
      function add(n) {
        if (typeof n === 'number' && !isNaN(n) && n >= 0) caps.push(n);
      }
      var vs = (config.variantStock || {})[state.variantId];
      add(typeof vs === 'number' ? vs : parseInt(vs, 10));
      if (state.mode === 'player' && state.player) {
        add(state.player.stock);
      } else if (state.mode === 'custom') {
        if (state.customName.trim() && config.nameAddon) add(config.nameAddon.stock);
        numberLines(state.customNumber).forEach(function (l) {
          add(l.info.stock);
        });
      }
      state.badges.forEach(function (b) {
        add(b.stock);
      });
      if (!caps.length) return Infinity;
      return Math.min.apply(null, caps);
    }

    // The stepper lives outside the <form> and is only bound by its form=
    // attribute, so form.elements finds it where querySelector does not
    var qtyInput = null;
    if (isPdp && pdpForm) {
      qtyInput = (pdpForm.elements && pdpForm.elements.quantity) || pdpForm.querySelector('[name="quantity"]') || document.querySelector('[name="quantity"]');
      if (qtyInput && qtyInput.length) qtyInput = qtyInput[0];
    }

    function currentQty() {
      var n = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      return n > 0 ? n : 1;
    }

    // Clamp the stepper so an unfulfillable quantity cannot be chosen
    function applyStockCap() {
      if (!qtyInput) return;
      var cap = bundleStock();
      if (cap === Infinity) {
        qtyInput.removeAttribute('data-jc-max');
        return;
      }
      qtyInput.setAttribute('data-jc-max', cap);
      qtyInput.max = cap;
      if (currentQty() > cap) qtyInput.value = cap > 0 ? cap : 1;
    }

    if (qtyInput) {
      qtyInput.addEventListener('change', applyStockCap);
      var stepper = qtyInput.closest('.quantity, .pdp-figma__stepper') || pdpForm;
      if (stepper) {
        stepper.addEventListener('click', function () {
          window.setTimeout(applyStockCap, 0);
        });
      }
    }

    // ---------- add to cart ----------
    // One line per printed thing sharing a _TRIKOT id; Cart Transform needs Plus
    function buildItems(trikotId) {
      var qty = isPdp ? currentQty() : 1;
      var items = [];
      var name = '';
      var number = '';
      if (state.mode === 'player' && state.player) {
        name = state.player.name;
        number = state.player.number;
      } else if (state.mode === 'custom') {
        name = state.customName.trim();
        number = state.customNumber.trim();
      }
      var flockStr = number && name ? number + ' ' + name : number || name;

      // _addon_type lets the cart total badges apart from the printing.
      // Underscore keys stay out of Shopify's checkout, where each add-on line already names
      // its print in its variant title; aico copies _FLOCK back to FLOCK at order intake (139911)
      function child(variantId, sku, flock, addonType, extra) {
        var props = { _TRIKOT: trikotId, _bundle_type: 'child', _addon_type: addonType };
        if (sku) props.SKU = sku;
        if (flock) props._FLOCK = flock;
        if (extra) {
          for (var k in extra) {
            if (Object.prototype.hasOwnProperty.call(extra, k)) props[k] = extra[k];
          }
        }
        return { id: variantId, quantity: qty, properties: props };
      }

      if (state.mode === 'player' && state.player) {
        // _FLOCK carries "number name", so the player line alone is the whole print
        items.push(child(state.player.variantId, state.player.sku, flockStr, 'spieler'));
      } else if (state.mode === 'custom') {
        if (name && config.nameAddon) {
          items.push(child(config.nameAddon.variantId, config.nameAddon.sku, name, 'individuell'));
        } else if (!name && number && config.noNameAddon) {
          items.push(child(config.noNameAddon.variantId, config.noNameAddon.sku, '', 'individuell', { _placeholder: 'name' }));
        }
        numberLines(number).forEach(function (l) {
          items.push(child(l.info.variantId, l.info.sku, 'Nr. ' + l.flock, 'nummer'));
        });
      }
      state.badges.forEach(function (b) {
        items.push(child(b.variantId, b.sku, b.title, 'badge'));
      });

      // The player print and the badges are hidden here (their add-on lines show them in
      // checkout; snippets/jc-print-summary shows them in the theme cart). A custom name
      // stays visible: the name add-on's variant title does not carry it
      var mainProps = { _TRIKOT: trikotId, _bundle_type: 'main' };
      if (config.jerseyType) mainProps._jersey_type = config.jerseyType;
      if (config.gender) mainProps._gender = config.gender;
      if (state.mode === 'custom') {
        if (number) mainProps[strings.propNumber || 'Numéro'] = number;
        if (name) mainProps[strings.propName || 'Nom'] = name;
      } else if (flockStr) {
        mainProps._FLOCK = flockStr;
      }
      if (state.badges.length) {
        mainProps._jc_badges = state.badges
          .map(function (b) {
            return b.title;
          })
          .join(', ');
      }
      // Main LAST: /cart/add.js inserts items[] in reverse
      items.push({ id: state.variantId, quantity: qty, properties: mainProps });
      return items;
    }

    // Drawer re-renders from section HTML in the add response, so the sections
    // must be requested up front (same contract as product-form.js)
    var cartDrawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');

    function sectionsToRequest() {
      if (!cartDrawer || typeof cartDrawer.getSectionsToRender !== 'function') return null;
      return cartDrawer.getSectionsToRender().map(function (s) {
        return s.id;
      });
    }

    function afterAdd(response) {
      // renderContents only clears is-empty from .drawer__inner, not the host
      if (cartDrawer && cartDrawer.classList.contains('is-empty')) {
        cartDrawer.classList.remove('is-empty');
      }
      if (cartDrawer && response && response.sections) {
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'jersey-configurator',
            productVariantId: state.variantId,
            cartData: response
          });
        }
        cartDrawer.renderContents(response);
        return;
      }
      window.location.href = cartRoot() + 'cart';
    }

    function submitBundle() {

      if (state.busy) return;

      if (!state.variantId) {
        if (isPdp) state.variantId = pdpVariantId();
        if (!state.variantId) {
          setError(sizeError, strings.chooseSize);
          setError(messages, strings.chooseSize);
          return;
        }
      }
      if (state.mode === 'player' && !state.player) {
        setError(messages, strings.choosePlayer);
        return;
      }
      if (state.mode === 'custom') {
        var n = state.customName.trim();
        var num = state.customNumber.trim();
        if (!n && !num) {
          setError(messages, needsBoth ? strings.nameNumberTogether || strings.chooseCustom : strings.chooseCustom);
          return;
        }
        if (customIncomplete()) {
          setError(messages, strings.nameNumberTogether || strings.chooseCustom);
          return;
        }
        var issue = numberIssue(num);
        if (issue) {
          setError(customError, issue);
          setError(messages, issue);
          return;
        }
      }

      setError(messages, '');
      state.busy = true;
      if (submit) submit.disabled = true;

      // Group id for this bundle. Random rather than sequential: two tabs can add to the same cart, and a collision would merge two shoppe
      var trikotId =
        window.crypto && window.crypto.randomUUID
          ? window.crypto.randomUUID()
          : String(Math.floor(Math.random() * 1e12));

      var payload = { items: buildItems(trikotId) };
      var sections = sectionsToRequest();
      if (sections) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }

      fetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload)
      })
        .then(function (r) {
          if (!r.ok) {
            return r.json().then(function (d) {
              throw new Error((d && d.description) || strings.addToCartFailed);
            });
          }
          return r.json();
        })
        .then(function (response) {
          afterAdd(response);
        })
        .catch(function (err) {
          setError(messages, (err && err.message) || strings.addToCartFailed);
        })
        .then(function () {
          state.busy = false;
          if (submit) submit.disabled = cartLocked;
        });
    }

    if (submit) {
      submit.addEventListener('click', submitBundle);
    }

    // ---------- boot ----------
    if (isPdp) {
      // The overlay belongs to the gallery's back image, outside this element
      (function mountPdpPrint() {
        if (!backMediaId) return;
        var item = document.querySelector('.product__media-item[data-media-id$="-' + backMediaId + '"]');
        var host = item && item.querySelector('.product__media');
        if (!host || host.querySelector('[data-jc-print]')) return;
        var stage = document.createElement('div');
        stage.className = 'jc-print-stage';
        stage.setAttribute('style', root.getAttribute('data-jc-print-vars') || '');
        stage.innerHTML =
          '<div class="jc-print" data-jc-print aria-hidden="true">' +
          '<div class="jc-print-name" data-jc-print-name></div>' +
          '<div class="jc-print-number" data-jc-print-number></div>' +
          '</div>';
        host.appendChild(stage);
        fitToPhoto(stage, host.querySelector('img'));
        printBox = stage.querySelector('[data-jc-print]');
        printName = stage.querySelector('[data-jc-print-name]');
        printNumber = stage.querySelector('[data-jc-print-number]');
      })();

      state.variantId = pdpVariantId();
      state.sizeSelected = !!state.variantId;
      // The picker swaps the hidden id input on every variant change
      document.addEventListener('change', function () {
        var id = pdpVariantId();
        if (id) {
          state.variantId = id;
          state.sizeSelected = true;
          var v = (config.variantPrices || {})[id];
          if (typeof v === 'number') state.variantPrice = v;
          // The theme re-renders the price node on a variant swap
          pdpPriceEl = document.querySelector('.pdp-figma__price .price-item--regular, .pdp-figma__price .price-item');
          applyPrice();
        }
      });
      if (pdpForm) {
        pdpForm.addEventListener(
          'submit',
          function (e) {
            if (customIncomplete()) {
              e.preventDefault();
              e.stopImmediatePropagation();
              setError(messages, strings.nameNumberTogether || strings.chooseCustom);
              return;
            }
            // Only take over once something is printed; plain jerseys use the theme path
            if (!isPersonalized() && !state.badges.length) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            submitBundle();
          },
          true
        );
      }
    } else if (printBox) {
      fitToPhoto(printBox, printBox.parentElement.querySelector('img'));
    }

    if (printBox && window.ResizeObserver) new ResizeObserver(fitName).observe(printBox);
    if (document.fonts && document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', fitName);

    setupCarousel();
    syncBadgesNote();
    refreshPatches();
    restore(takeCarry());
    refreshPrint();
    applyPrice();
  }

  function initAll() {
    document.querySelectorAll('[data-jc]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
